var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-scrollbar__wrap wrap-white padding-20" },
    [
      _c(
        "div",
        { staticClass: "el-scrollbar__view" },
        [
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { gutter: 20 },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("h3", [_vm._v("数据模型配置")]),
                      ]),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 12 },
                        },
                        [
                          _vm.$route.query.method != "view"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.doSubmit },
                                },
                                [_vm._v("保存数据模型")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "info", size: "small" },
                              on: { click: _vm.goBack },
                            },
                            [_vm._v("返回")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      ref: "inputForm",
                      attrs: {
                        size: "small",
                        model: _vm.inputForm,
                        "label-width": "150px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "目标数据库",
                            prop: "dataSource.id",
                            rules: [
                              {
                                required: true,
                                message: "目标数据库不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("SelectTree", {
                            ref: "dataSource",
                            attrs: {
                              props: {
                                value: "id", // ID字段名
                                label: "label", // 显示名称
                                children: "children", // 子级字段名
                              },
                              url: "/database/datalink/dataSource/treeData",
                              value: _vm.inputForm.dataSource.id,
                              clearable: true,
                              accordion: true,
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.dataSource.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "模型名称",
                            prop: "name",
                            rules: [
                              {
                                required: true,
                                message: "模型名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写模型名称" },
                            model: {
                              value: _vm.inputForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "name", $$v)
                              },
                              expression: "inputForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "sql语句",
                            prop: "sqlCmd",
                            rules: [
                              {
                                required: true,
                                message: "sql语句不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("editor", {
                            staticStyle: { border: "1px solid #d9d9d9" },
                            attrs: { lang: "sql", height: "200px" },
                            on: { init: _vm.editorInitSQL },
                            model: {
                              value: _vm.inputForm.sqlCmd,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "sqlCmd", $$v)
                              },
                              expression: "inputForm.sqlCmd",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-table",
                    { attrs: { data: _vm.paramForm.tableData } },
                    [
                      _c("el-table-column", {
                        attrs: { type: "index", width: "50" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "field", label: "参数名" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入内容" },
                                  model: {
                                    value: scope.row.field,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "field", $$v)
                                    },
                                    expression: "scope.row.field",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "defaultValue", label: "默认值" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入内容" },
                                  model: {
                                    value: scope.row.defaultValue,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "defaultValue", $$v)
                                    },
                                    expression: "scope.row.defaultValue",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        key: Math.random(),
                        attrs: { fixed: "right", label: "操作" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.deleteRow(
                                          scope.$index,
                                          _vm.paramForm.tableData
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 移除 ")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "10px",
                      },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.addRow },
                    },
                    [_vm._v("增加参数")]
                  ),
                  _c("el-alert", {
                    attrs: {
                      title:
                        "SQL中添加参数的方式：格式：{#参数名#}，示例：select * from table where id = '{#ID#}'",
                      closable: false,
                      type: "success",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "10px",
                      },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.doPreviewTable },
                    },
                    [_c("i", { staticClass: "fa fa-eye" }), _vm._v(" 解析")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "10px",
                      },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.doPreviewData },
                    },
                    [_c("i", { staticClass: "fa fa-eye" }), _vm._v(" 预览数据")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("h3", [_vm._v("数据源列配置")]),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.columnForm.columnList },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "字段名" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "type", label: "类型" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "label", label: "标签" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.label,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "label", $$v)
                                    },
                                    expression: "scope.row.label",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "el-table-column",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-checkbox", {
                                    on: { change: _vm.handleCheckedNeedChange },
                                    model: {
                                      value: scope.row.isNeed,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "isNeed", $$v)
                                      },
                                      expression: "scope.row.isNeed",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { indeterminate: _vm.isIndeterminate },
                                  on: { change: _vm.handleCheckAllChange },
                                  model: {
                                    value: _vm.columnForm.isNeedAll,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.columnForm, "isNeedAll", $$v)
                                    },
                                    expression: "columnForm.isNeedAll",
                                  },
                                },
                                [_vm._v("参与分析")]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              attrs: { title: "数据预览", visible: _vm.previewVisible },
              on: {
                "update:visible": function ($event) {
                  _vm.previewVisible = $event
                },
              },
            },
            [
              _c(
                "el-tabs",
                { attrs: { type: "border-card" } },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "HTML" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { height: "500px", width: "100%" },
                          attrs: { data: _vm.previewData.json },
                        },
                        _vm._l(
                          _vm.previewData.column,
                          function (value, key, index) {
                            return _c("el-table-column", {
                              key: index,
                              attrs: { prop: key, label: key, width: "180" },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "JSON" } },
                    [
                      _c("editor", {
                        attrs: {
                          lang: "json",
                          theme: "twilight",
                          width: "100%",
                          height: "500px",
                        },
                        on: { init: _vm.editorInitJSON },
                        model: {
                          value: _vm.previewData.json_str,
                          callback: function ($$v) {
                            _vm.$set(_vm.previewData, "json_str", $$v)
                          },
                          expression: "previewData.json_str",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "XML" } },
                    [
                      _c("editor", {
                        attrs: {
                          lang: "xml",
                          theme: "twilight",
                          width: "100%",
                          height: "500px",
                        },
                        on: { init: _vm.editorInitXML },
                        model: {
                          value: _vm.previewData.xml,
                          callback: function ($$v) {
                            _vm.$set(_vm.previewData, "xml", $$v)
                          },
                          expression: "previewData.xml",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }